var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7 8.3C19.3 7.9 18.7 7.9 18.3 8.3L8.3 18.3C8.1 18.5 8 18.7 8 19V23C8 23.6 8.4 24 9 24H13C13.3 24 13.5 23.9 13.7 23.7L23.7 13.7C24.1 13.3 24.1 12.7 23.7 12.3L19.7 8.3ZM12.6 22H10V19.4L16 13.4L18.6 16L12.6 22ZM17.4 12L20 14.6L21.6 13L19 10.4L17.4 12Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeIcon);
export default __webpack_public_path__ + "static/media/changeIcon.9a203e7ad21148e1069b36ce279c2283.svg";
export { ForwardRef as ReactComponent };